module.exports = __webpack_public_path__ + "assets/7a1551c8b70156a77099076eee7913b7.mp4";